<template>
    <div class="brand">
        <router-link to="/" class="router-link">
            <img src="@/assets/images/logo.svg" alt="Logo Asuaire">
        </router-link>
    </div>
</template>
<script>
export default {
    name: 'nav-logo',
    methods: {
        goHome() {
            this.$router.push({ name: 'RouteHome'});
        }
    }
}
</script>